import {Component, Inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {AuthenticationService} from '../../_services/authentication.service';
import {ToastrService} from 'ngx-toastr';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {LookupService} from '../../_services/lookup.service';
import {UtilityService} from '../../_helpers/utility.service';
import {FormBuilder} from '@angular/forms';
import {Requests} from '../../_model/Requests';
import {RequestService} from '../../_services/request.service';
import {StorageService} from '../../_services/storage.service';
import {ListDocumentRequest} from '../../_model/request/ListDocumentRequest';
import {TABLE_LIST} from '../../_utils/constants';
import {PortalDocumentResponse} from '../../_model/response/PortalDocumentResponse';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-requestsdetail',
  templateUrl: './requestsdetail.component.html',
  styleUrls: ['./requestsdetail.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class RequestsdetailComponent implements OnInit {

  listDocumentRequest: ListDocumentRequest;
  portalDocumentList: PortalDocumentResponse[] = [];
  spinnerShow = false;
  fileUploadRootPath: string;
  //rejectDescription:rejectDescription;
  constructor(private requestService: RequestService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              public dialogRef: MatDialogRef<RequestsdetailComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Requests,
              private authService: AuthenticationService,
              private lookupService: LookupService,
              private utilityService: UtilityService,
              private requestsService: RequestService,
              private storageServie: StorageService) {
    this.fileUploadRootPath = environment.fileUploadPath;
  }

  ngOnInit() {
    this.listDocumentRequest =  new ListDocumentRequest(TABLE_LIST.REQUESTS, this.data.id);
    this.storageServie.listDocuments(this.listDocumentRequest).subscribe(documentListResult => {
      this.portalDocumentList = [...documentListResult.responseData.items];
    });
  }

  closeModal() {
      this.dialogRef.close();
  }

}
